"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("devextreme/data/odata/store");

var _dataGrid = _interopRequireWildcard(require("devextreme-react/data-grid"));

var _reactRouterDom = require("react-router-dom");

var _common = _interopRequireDefault(require("../function/common"));

var _Loader = _interopRequireDefault(require("./Loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Componente per la gestione della griglia.
 * Di seguito le proprietà per la composizione:
 *    <DxGrid 
        data={default:[DATI], columns:[COLONNE]}          Data della griglia compilata con DATI E COLONNE
        data-key="uuid"                                   Campo chiave del record sulla griglia
        gridUpdate = {this.handleToUpdate.bind(this)}     Metodo per l'aggiornamento della griglia
        delete={{permission:"account.deleteAccess"}}      Permesso di cancellazione; se compilato visualizza l'icona di cancellazione
        update={{permission: "account.updateAccess",      Permesso di update; se compilato visualizza l'iconda di update e rimanda al path indicato
                pathname:"/portal/account-page",
                search: `?parent=${common.session.fn_getUserUuid()}&uuid=#KEY#`}}>                                
      </DxGrid>    

      PROPRIETA' OGGETTO COLONNE: 
          field: IMPOSTA IL VALORE DEL CAMPO E LA CHIAVE DELLA COLONNA
          text: IMPOSTA IL TESTO DELL'HEADER
          type: IMPOSTA LA TIPOLOGIA DELLA COLONNA
          allowHeaderFiltering: IMPOSTA SE LA COLONNA E' FILTRABILE O MENO
          width: LARGHEZZA COLONNA

 */
var DxGrid = /*#__PURE__*/function (_Component) {
  _inherits(DxGrid, _Component);

  var _super = _createSuper(DxGrid);

  function DxGrid(props) {
    var _this;

    _classCallCheck(this, DxGrid);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "dataSource", []);

    _defineProperty(_assertThisInitialized(_this), "columns", []);

    _defineProperty(_assertThisInitialized(_this), "delete", false);

    _defineProperty(_assertThisInitialized(_this), "permissionDelete", "");

    _defineProperty(_assertThisInitialized(_this), "dataKey", "");

    _defineProperty(_assertThisInitialized(_this), "update", false);

    _defineProperty(_assertThisInitialized(_this), "print", false);

    _defineProperty(_assertThisInitialized(_this), "permissionUpdate", "");

    _defineProperty(_assertThisInitialized(_this), "pathUpdate", "");

    _defineProperty(_assertThisInitialized(_this), "searchUpdate", "");

    _this.dataSource = _this.props.data["default"];
    _this.columns = _this.props.data["columns"];
    _this.prints = _this.props.data["print"];
    _this.dataKey = _this.props["data-key"];
    _this.gridUpdate = _this.props["gridUpdate"];

    if (_this.props["delete"] !== undefined) {
      _this.permissionDelete = _this.props["delete"]["permission"];

      if (_common.default.service.checkPermission(_this.permissionDelete)) {
        _this.delete = true;
      }
    }

    if (_this.props["update"] !== undefined) {
      _this.permissionUpdate = _this.props["update"]["permission"];

      if (_common.default.service.checkPermission(_this.permissionUpdate)) {
        _this.update = true;
      }

      _this.pathUpdate = _this.props["update"]["pathname"];
      _this.searchUpdate = _this.props["update"]["search"];
    }

    if (_this.prints !== undefined) {
      _this.permissionPrint = _this.props["print"]["permission"];

      if (_common.default.service.checkPermission(_this.permissionPrint)) {
        _this.print = true;
      }
    }

    _this.state = {
      loadPanelVisible: false
    };
    return _this;
  }

  _createClass(DxGrid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "dxGrid"
      }, /*#__PURE__*/_react.default.createElement(_Loader.default, {
        visible: this.state.loadPanelVisible
      }), /*#__PURE__*/_react.default.createElement(_dataGrid.default, {
        dataSource: this.props.data["default"],
        allowColumnReordering: this.props.allowColumnReordering,
        showBorders: true //onContentReady={this.onContentReady}

      }, /*#__PURE__*/_react.default.createElement(_dataGrid.HeaderFilter, {
        visible: this.props.headerFilterVisible
      }), /*#__PURE__*/_react.default.createElement(_dataGrid.GroupPanel, {
        visible: this.props.groupPanelVisible
      }), /*#__PURE__*/_react.default.createElement(_dataGrid.Grouping, {
        autoExpandAll: false
      }), this.delete ? /*#__PURE__*/_react.default.createElement(_dataGrid.Column, {
        key: "delete",
        caption: "",
        width: 35,
        allowSorting: false,
        cellRender: cellRenderDelete,
        clickFunction: this.handleDelete.bind(this),
        dataKey: this.dataKey
      }) : '', this.print ? /*#__PURE__*/_react.default.createElement(_dataGrid.Column, {
        key: "print",
        caption: "",
        width: 35,
        allowSorting: false,
        cellRender: cellRenderPrint,
        clickFunction: this.handlePrint.bind(this),
        dataKey: this.dataKey,
        dataPrints: this.dataPrints
      }) : '', this.update ? /*#__PURE__*/_react.default.createElement(_dataGrid.Column, {
        key: "update",
        caption: "",
        width: 35,
        allowSorting: false,
        cellRender: cellRenderUpdate,
        pathUpdate: this.pathUpdate,
        searchUpdate: this.searchUpdate,
        dataKey: this.dataKey
      }) : '', this.columns.map(function (column) {
        return /*#__PURE__*/_react.default.createElement(_dataGrid.Column, {
          key: column.field.toLowerCase().indexOf(" as ") > -1 ? column.field.substring(column.field.toLowerCase().lastIndexOf(" as ") + 4, column.field.length) : column.field,
          caption: column.text,
          dataField: column.field.toLowerCase().indexOf(" as ") > -1 ? column.field.substring(column.field.toLowerCase().lastIndexOf(" as ") + 4, column.field.length) : column.field,
          dataType: column.type,
          allowHeaderFiltering: column.allowHeaderFiltering,
          width: column.width,
          format: column.type === "datetime" ? "dd/MM/yyyy HH:mm:ss" : column.type === "date" ? "dd/MM/yyyy" : "",
          customizeText: column.type === "datetime" || column.type === "date" ? '' : textFormatting
        });
      }), /*#__PURE__*/_react.default.createElement(_dataGrid.Pager, {
        allowedPageSizes: this.props.pageSize,
        showPageSizeSelector: this.props.showPageSizeSelector
      }), /*#__PURE__*/_react.default.createElement(_dataGrid.Paging, {
        defaultPageSize: this.props.defaultPageSize
      })));
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(uuid) {
      var thisClass = this;

      _common.default.notify.fn_confirm("Sei sicuro di voler eliminare il record selezionato?", function () {
        return thisClass.deleteAccess(thisClass, uuid);
      });
    }
  }, {
    key: "handlePrint",
    value: function handlePrint(uuid) {
      var _this2 = this;

      if (this.prints.length === 1) {
        var name = this.prints[0]["name"];
        var param = this.prints[0]["param"];
        var fileName = this.prints[0]["fileName"];
        var thisClass = this;

        _common.default.service.postData(thisClass, this.props["print"]["pathname"], {
          "data": {
            "fileName": fileName,
            "name": name,
            "param": param,
            "key": uuid
          }
        }).then(function (data) {
          _common.default.notify.notifyServerResponse(thisClass, data, "", thisClass.viewReport.bind(_this2, data.data, fileName));
        });
      }
    }
  }, {
    key: "viewReport",
    value: function viewReport(base64, fileName) {
      console.log(base64);
      var link = document.createElement('a');
      link.href = "data:application/pdf;base64," + base64;
      link.target = "_blank";
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, {
    key: "deleteAccess",
    value: function deleteAccess(thisClass, uuid) {
      _common.default.service.postData(thisClass, '/account/deleteAccess/' + uuid).then(function (data) {
        _common.default.notify.notifyServerResponse(thisClass, data, "Record eliminato correttamente", thisClass.gridUpdate());
      });
    }
  }]);

  return DxGrid;
}(_react.Component);

function textFormatting(cellInfo) {
  return cellInfo.value + '';
}
/*function  dateTimeFormatting(cellInfo) {    
  return common.date.writePreviewDateTimeByVB(cellInfo.value);
}*/


function cellRenderUpdate(data) {
  var search = data.column.searchUpdate;
  var keyField = data.column.dataKey;
  search = search.replace("#KEY#", data.key[keyField]);
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
    to: {
      pathname: data.column.pathUpdate,
      search: search
    },
    activeClassName: "active"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-edit orange"
  }));
} //<img src={icon_update}></img>


function cellRenderDelete(data) {
  var keyField = data.column.dataKey; //return <img src={icon_delete} onClick={() => data.column.clickFunction(data.key[keyField])}></img> ;

  return /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-times red pointer",
    onClick: function onClick() {
      return data.column.clickFunction(data.key[keyField]);
    }
  });
}

function cellRenderPrint(data) {
  var keyField = data.column.dataKey;
  return /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-print green pointer",
    onClick: function onClick() {
      return data.column.clickFunction(data.key[keyField]);
    }
  });
}

DxGrid.defaultProps = {
  defaultPageSize: 10,
  allowColumnReordering: false,
  showPageSizeSelector: false,
  allowedPageSizes: [],
  headerFilterVisible: true,
  groupPanelVisible: false,
  columns: []
};
var _default = DxGrid;
exports.default = _default;